<script>
  import { onMount } from "svelte";
  import { loadCharts } from "../api";
  import { PHP } from "../store";
  import CircleLoader from "../utils/CircleLoader.svelte";
  import Placeholder from "../utils/Placeholder.svelte";
  import Description from "./Description.svelte";
  import to from "await-to-js";
  // Do not change this to es6 import (Color conflict https://github.com/chartjs/Chart.js/issues/3168)
  const Chart = require('chart.js');

  let isLoading = false;
  let isEmpty = true;
  let totalVisitor = 0;
  let totalSubscription = 0;
  let showInstallsChart = false;

  const loadData = async () => {
    isLoading = true;

    const [error, response] = await to(loadCharts());

    isLoading = false;
    // There is an error in request
    // Do not process any more
    if (error) return (isEmpty = true);

    if (response.status === 200) {
      let active_data = [];
      let total_data = [];
      let installs_data = [];
      let uninstalls_data = [];
      let labels = [];
      totalVisitor = response.data.total_installs;
      totalSubscription = response.data.active_installs;

      // Response is empty so do not continue
      if (response.data.historical.length === 0) return;

      // Make this false before followin
      // to be able to show the data
      isEmpty = false;

      response.data.historical.forEach(function(item, index) {
        active_data.push(item["active"]);
        total_data.push(item["total"]);
        if (item["last_installs"] !== undefined)
          installs_data.push(item["last_installs"]);
        if (item["last_uninstalls"] !== undefined)
          uninstalls_data.push(item["last_uninstalls"]);
        labels.push(item["created_at"]);
      });

      showInstallsChart = installs_data.length > 0;

      var ctx = document.getElementById("total-chart").getContext("2d");
      var chart = new Chart(ctx, {
        type: "line",
        responsive: true,
        data: {
          labels: labels,
          datasets: [
            {
              label: "Subscriptions",
              backgroundColor: "rgba(0,101,255,0.3)",
              borderColor: "rgb(0,101,255)",
              data: active_data
            }
          ]
        },
        options: {
          responsive: true,
          legend: {
            position: "bottom"
          }
        }
      });

      if (showInstallsChart) {
        var dctx = document.getElementById("daily-chart").getContext("2d");
        var dailyChart = new Chart(dctx, {
          type: "line",
          data: {
            labels: labels,
            datasets: [
              {
                label: "Installs",
                backgroundColor: "rgba(0,255,76,0.3)",
                borderColor: "rgb(0,255,76)",
                data: installs_data
              },
              {
                label: "Uninstalls",
                backgroundColor: "rgb(255, 99, 132,0.3)",
                borderColor: "rgb(255, 99, 132)",
                data: uninstalls_data
              }
            ]
          },
          options: {
            responsive: true,
            legend: {
              position: "bottom"
            }
          }
        });
      }
    }
  };

  onMount(async () => {
    if ($PHP.isActivated) await loadData();
  });
</script>

<style>
  .notification {
    min-height: 200px;
  }
  .hidden {
    display: none;
  }
</style>

<div class="container is-fluid">
  <div class="notification">
    <Description />
    {#if isLoading}
      <CircleLoader />
    {:else if isEmpty}
      <Placeholder text="Nothing to show yet" icon="chart" />
    {/if}

    <div class="notification" class:is-hidden={isEmpty || isLoading}>
      <div class="columns">
        <div class="column">
          <div class="box">
            <div class="level">
              <div class="level-left">Total Visitors</div>
              <div class="level-right title">{totalVisitor}</div>
            </div>
          </div>
        </div>
        <div class="column ">
          <div class="box">
            <div class="level">
              <div class="level-left">Total Subscription</div>
              <div class="level-right title">{totalSubscription}</div>
            </div>

          </div>
        </div>
      </div>
      <div class="columns is-desktop" class:is-centered={!showInstallsChart}>
        <div class="column" class:is-half={!showInstallsChart}>
          <canvas id="total-chart" />
        </div>
        <div class="column" class:hidden={!showInstallsChart}>
          <canvas id="daily-chart" />
        </div>
      </div>
    </div>
  </div>
</div>
